import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoanPayload, NewLoansService } from './new-loans.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CanCreateLoanGuard implements CanActivate, CanActivateChild {
  constructor(private newLoanSvc: NewLoansService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canCreate();
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canCreate();
  }

  canCreate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.newLoanSvc.hasAutosave) return true;
    return this.newLoanSvc.getLoanByPartnerType().pipe(
      map((loanResponse) => {
        if (typeof loanResponse === 'boolean' && !loanResponse) {
          this.router.navigate(['home']);
          return false;
        } else {
          const loanInfo = loanResponse as LoanPayload;
          if (loanInfo.payload.partner.canCreateLoan) {
            return true;
          }
        }
        this.router.navigate(['home']);
        return false;
      })
    );
  }
}
